import { render, staticRenderFns } from "./expandCollapse.vue?vue&type=template&id=4961172a&scoped=true"
import script from "./expandCollapse.vue?vue&type=script&lang=js"
export * from "./expandCollapse.vue?vue&type=script&lang=js"
import style0 from "./expandCollapse.vue?vue&type=style&index=0&id=4961172a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4961172a",
  null
  
)

export default component.exports